var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 20,
    viewBox: "0 0 125 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 15.77L16.513 19.5L14.873 12.47L20.333 7.74L13.143 7.13L10.333 0.5L7.52301 7.13L0.333008 7.74L5.79301 12.47L4.15301 19.5L10.333 15.77Z",
    fill: "#FF947A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.333 15.77L42.513 19.5L40.873 12.47L46.333 7.74L39.143 7.13L36.333 0.5L33.523 7.13L26.333 7.74L31.793 12.47L30.153 19.5L36.333 15.77Z",
    fill: "#FF947A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.333 15.77L68.513 19.5L66.873 12.47L72.333 7.74L65.143 7.13L62.333 0.5L59.523 7.13L52.333 7.74L57.793 12.47L56.153 19.5L62.333 15.77Z",
    fill: "#FF947A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.333 15.77L94.513 19.5L92.873 12.47L98.333 7.74L91.143 7.13L88.333 0.5L85.523 7.13L78.333 7.74L83.793 12.47L82.153 19.5L88.333 15.77Z",
    fill: "#FF947A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.333 7.74L117.143 7.12L114.333 0.5L111.523 7.13L104.333 7.74L109.793 12.47L108.153 19.5L114.333 15.77L120.513 19.5L118.883 12.47L124.333 7.74ZM114.333 13.9L110.573 16.17L111.573 11.89L108.253 9.01L112.633 8.63L114.333 4.6L116.043 8.64L120.423 9.02L117.103 11.9L118.103 16.18L114.333 13.9Z",
    fill: "#FF947A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.69777946f9a0a2ebdcd51b39339adce9.svg";
export { ForwardRef as ReactComponent };